import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import getTableHeaders from './getTableHeaders';
import getMobileSortingOptions from 'components/data-containers/BrowseEntities/shared/getMobileSortingOptions';

import { RootState } from 'redux/rootReducer';
import { TTableHeader } from 'components/CustomizeView/CustomizeView';

const useBrowseTableHeaders = (props: any): any => {
  const { browseEntityType, tableHeadersType, tableType } = props;

  const savedTableHeaders = useSelector(
    (state: RootState): any => (state.browseTable as any)[tableType]?.data || []
  );

  const standardTableHeaders = useMemo(
    () => getTableHeaders(browseEntityType, tableHeadersType),
    [browseEntityType, tableHeadersType]
  );
  const sortingOptions = useMemo(() => {
    if (browseEntityType === 'label') {
      return standardTableHeaders;
    }

    return getMobileSortingOptions(browseEntityType, tableHeadersType);
  }, [browseEntityType, standardTableHeaders, tableHeadersType]);

  const displayNameHeader = {
    label: `${browseEntityType} info`,
    value: 'displayName',
    key: `displayName`,
  };
  const savedTableHeadersWithDisplayName = useMemo(
    () => [displayNameHeader, ...savedTableHeaders],
    [displayNameHeader, savedTableHeaders]
  );
  const tableHeaders = useMemo(
    () =>
      savedTableHeaders && savedTableHeaders.length > 0
        ? savedTableHeadersWithDisplayName
        : standardTableHeaders,
    [savedTableHeaders, savedTableHeadersWithDisplayName, standardTableHeaders]
  );

  const mobileDisplayNameHeader = useMemo(
    () =>
      sortingOptions.filter(
        (header: TTableHeader) => header.value === 'displayName'
      ),
    [sortingOptions]
  );

  const mobileTableHeaders = useMemo(
    () =>
      savedTableHeaders.length > 0
        ? [...mobileDisplayNameHeader].concat(
            savedTableHeaders.reduce((prev: any, header: TTableHeader) => {
              return prev.concat(
                sortingOptions.filter(
                  (mobile: TTableHeader) => header.value === mobile.value
                )
              );
            }, [])
          )
        : sortingOptions,
    [sortingOptions, savedTableHeaders, mobileDisplayNameHeader]
  );

  if (browseEntityType === 'label') {
    return {
      mobileHeaders: sortingOptions,
      tableHeaders: standardTableHeaders,
    };
  }

  return {
    mobileHeaders: mobileTableHeaders,
    tableHeaders,
  };
};

export default useBrowseTableHeaders;
